import React, { useState } from "react";
import { styled } from "../../stitches.config";
import Cookies from "cookies-js"

import Link from "../Link";
import CircleButton from '../CircleButton'
import SwitchText from './SwitchText'

import { bridVote } from './bridVote'

const BridTileSmall1 = props => {
  const { article, secondArticleID, thirdArticleID, voted, percentage, uID, hasCookie, votingResult } = props;
  const imageHeight = (props.imageHeight > 0 ? props.imageHeight : 154);
  const articlesGroup = [article.articleID, secondArticleID, thirdArticleID]
  var imgUrl = (article.picture && article.picture.img ? article.picture.img : window.MEDIA_DOMAIN + '/3586c2268e6bcd1271b48c546d29183a,780,0,0,0.jpg');
  if (props.size == 'lg') {
    imgUrl = imgUrl.replace("780,0,0,0", "555,286,1,0");
  } else {
    imgUrl = imgUrl.replace("780,0,0,0", "721," + imageHeight + ",1,0");
  }

  const fetchVotes = async () => {
    const votes = await bridVote(article.articleID, articlesGroup)
      .catch(err => console.log(err))

    if (votes) {
      props.setPercentage(votes.data?.articlesAverage);
      props.setVoted(article.articleID);
      if (uID) Cookies.set('_brid', `${props.uID}.${article.articleID}`, { expires: 86400 })
    }
  }

  return (
    <BoxWrapper className={article.background ? 'background--' + article.background : null + " photo-on-top"}>
      <ImageWrapper>
        <img alt="" src={imgUrl} />
      </ImageWrapper>
      <Title className="photo-on-top__title" size={props.size}>
        <p>{article.title}</p>
        {
          hasCookie
            ? <Thankyou>{votingResult[article.articleID]}% głosów</Thankyou>
            : <>
              {voted === null ?
                <CircleButton
                  onClick={fetchVotes}>
                  Oddaj głos
                </CircleButton> : <SwitchText
                  firstText={voted === article.articleID && 'Dziękujemy za oddany głos!'}
                  secondText={`${percentage[article.articleID]}% głosów`}
                  render={data => (<Thankyou>{data}</Thankyou>)}
                />}
            </>
        }
      </Title>
    </BoxWrapper>
  );
};

const Title = styled("span", {
  display: "block",
  position: "relative",
  fontWeight: 400,
  fontSize: "16px",
  letterSpacing: "-0.32px",
  color: "#272424",
  "& > p": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "13px 13px 0 13px",
    paddingBottom: "60px"
  },
  "button": {
    margin: "10px",
    position: "absolute",
    bottom: "0"
  },
  "@media (min-width: 992px)": {
    height: "128px",
    "& > p": {
      marginBottom: "68px",
      height: "68px"
    }
  }
});

export const Thankyou = styled("span", {
  display: "block",
  position: "absolute",
  margin: "10px",
  fontSize: "19px",
  bottom: "12px",
  color: "$primary"
});

const BoxWrapper = styled("div", {
  backgroundColor: "#FFFFFF",
  padding: "12px 0",
  position: "relative",
  "> a": {
    border: "1px solid rgba(151,151,151,0.15)",
    borderWidth: "0 0 2px 2px",
    borderRadius: "0 0 0 5px",
    backgroundColor: "#FFFFFF",
    textDecoration: "none",
    display: "block",
    position: "relative",
    "&:hover": {
      textDecoration: "none"
    }
  },
  "&.background": {
    "&--red": {
      "> a": {
        backgroundColor: "#ED2024"
      },
      [`& ${Title}`]: {
        color: "white"
      },
      "&:hover": {
        [`& ${Title}`]: {
          color: "white"
        }
      }
    },
    "&--black": {
      "> a": {
        backgroundColor: "black"
      },
      [`& ${Title}`]: {
        color: "white"
      },
      "&:hover": {
        [`& ${Title}`]: {
          color: "white"
        }
      }
    }
  }
});

const ImageWrapper = styled("span", {
  display: "block",
  position: "relative",
  marginLeft: "-1px",
  "img": {
    width: "100%",
    height: "auto",
    display: "block"
  }
});

export default BridTileSmall1;